import { useEffect } from "react";

const setMeta = (selector, content) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute("content", content);
};

export const Seo = ({ title, description, keywords }) => {
  useEffect(() => {
    document.title = title;
    setMeta('meta[name="description"]', description);
    if (keywords) setMeta('meta[name="keywords"]', keywords);
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[property="og:description"]', description);
    setMeta('meta[name="twitter:title"]', title);
    setMeta('meta[name="twitter:description"]', description);
  }, [title, description, keywords]);
  return null;
};
